import { Select, SelectOption } from '@zoopla-eng/zds-components/select';
import { useRouter } from 'next/router';
import { ParsedUrlQuery } from 'querystring';
import { trackOnChange } from './SortOrder.tracking';
import { getResultsSort } from './utils/getResultsSort';
import { getSearchType } from './utils/getSearchType';
import { getSortOrderOptions } from './utils/getSortOrderOptions';
import { dropDownMenuStyle } from './utils/SortOrder.styles.css';

export const SortOrder = () => {
    const { query, push, pathname: currentPageRouteFilePath } = useRouter();

    const resultsSort = getResultsSort(query);
    const searchType = getSearchType(currentPageRouteFilePath);
    const sortOrderOptions = getSortOrderOptions();

    const options = sortOrderOptions[searchType]['options'];
    const defaultOption = sortOrderOptions[searchType]['default'];

    const onChange = (option: SelectOption) => {
        trackOnChange(option.id);

        // 'search-path' is the name of the dynamic route parameter and so we should not apply as a genuine query param below
        const { 'search-path': invalid, ...validParams } = query;

        const pathname = [searchType, ...getSearchPath(query)];

        const updatedPathname = `/${pathname.join('/')}/`;

        push({
            pathname: updatedPathname,
            query: { ...validParams, results_sort: option.id }
        });
    };

    return (
        <div className={dropDownMenuStyle}>
            <Select
                data-testid="sort-order-dropdown"
                label="Sort order"
                selectedOption={
                    options.find((option) => option.id === resultsSort) ??
                    defaultOption
                }
                onSelectedOptionChange={onChange}
                options={options}
                labelAlignment="left"
            />
        </div>
    );
};

function getSearchPath(query: ParsedUrlQuery) {
    if (query['search-path']) {
        // there is a bug in LSRP and perhaps Next itself where pushing to the router (and triggering GIP) causes the url params to appear as a path part in router.query['search-path'] i.e ['property', 'london', '?q=london'] also we want to remove _static from the serch-path query if on static page
        const searchPath = Array.isArray(query['search-path'])
            ? query['search-path']
            : [query['search-path']];
        const validSearchPath = searchPath.filter(
            (v) =>
                !v.startsWith('?') &&
                v !== '_static' &&
                v !== 'v1' &&
                v !== 'v2'
        );
        return validSearchPath;
    }

    return [];
}
